import { IStorageService } from "../StorageService";
import { StorageConstants } from "../../common/Constants";

let loggedIn: boolean | undefined = undefined;
let username: string = "";

export interface ICredentialService {
  setUsername(value: string): void;
  getUsername(): string;
  setLoggedIn(value: boolean): Promise<void>;
  getLoggedIn(): Promise<boolean>;
  setLanguage(value: string): Promise<void>;
  getLanguage(): Promise<string>;
}

const CredentialService = ({
  storageService
}: {
  storageService: IStorageService;
}): ICredentialService => {
  const _storageService: IStorageService = storageService;

  return {
    setUsername(value: string) {
      username = value;
    },
    getUsername() {
      return username;
    },
    async setLoggedIn(value: boolean) {
      loggedIn = value;
      _storageService.save(StorageConstants.LOGGED_IN, value);
    },
    async getLoggedIn() {
      if (loggedIn === undefined) {
        let value = await _storageService.get(StorageConstants.LOGGED_IN);
        loggedIn = value === "true";
      }
      return loggedIn;
    },
    async getLanguage() {
      return _storageService.get(StorageConstants.LANGUAGE);
    },

    async setLanguage(value: string) {
      _storageService.save(StorageConstants.LANGUAGE, value);
    }
  };
};

export default CredentialService;
